<label aria-label="Detalle">
  <em class="{{cssClass}} fa fa-lg fa-pencil-square-o" [routerLink]="routerLink"
    [matTooltip]="tooltip || 'Detalle'"></em>
</label>
